const PercentageIcon = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    width='119'
    height='123'
    viewBox='0 0 119 123'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M109.392 82.5956C99.6549 75.8515 86.2946 78.2784 79.5505 88.0159C72.8065 97.7528 75.2328 111.114 84.9703 117.858C94.7078 124.602 108.069 122.175 114.813 112.438C121.557 102.7 119.13 89.3396 109.392 82.5956ZM10.0581 39.5563C19.7956 46.3004 33.1564 43.874 39.9004 34.136C46.644 24.399 44.2176 11.0377 34.4801 4.29417C24.7432 -2.44987 11.3819 -0.0229979 4.6383 9.71447C-2.10624 19.4514 0.320636 32.8123 10.0581 39.5563ZM113.64 21.0992L22.2686 122.938L1.58198 104.377L92.9526 2.53874L113.64 21.0992Z'
      fill='currentColor'
    />
  </svg>
);

export default PercentageIcon;
